module.exports = __webpack_public_path__ + "img/horde_medium.358540bf.png";